export const loadHubspotChat = () => {
  if (document.getElementById('hs-script-loader')) return

  try {
    console.log('loading hubspot chat')
    const script = document.createElement('script')
    script.id = 'hs-script-loader'
    script.src = '//js-eu1.hs-scripts.com/145710253.js'
    script.setAttribute('defer', 'true')
    script.onerror = () => {
      console.error('Failed to load HubSpot chat script')
    }
    document.body.appendChild(script)
  } catch (err) {
    console.error('Error loading HubSpot chat:', err)
  }
}

let loadGTMScript = false
export function loadGtmScript(GTM_ID: string) {
  if (!GTM_ID || loadGTMScript) {
    return
  }

  // Initialize the data layer with default events if it doesn't already exist
  // Type assertion for the data layer
  window['dataLayer'] = window['dataLayer'] || []
  window['dataLayer'].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  })
  ;(function (
    w: {[key: string]: Array<Record<string, string | number>>},
    d: Document,
    s: 'script',
    l: string,
    i: string
  ) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement<'script'>(s)
    const dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode?.insertBefore(j, f)
    // @ts-expect-error window is not properly typed
  })(window, document, 'script', 'dataLayer', GTM_ID)

  loadGTMScript = true
}
